import { useState, useEffect, useContext, useCallback } from "react";
import { b as isWindowDefined } from "./index-CJNq9Per.js";
import { T as TEST_MODE_QUERY_PARAM } from "./index-1iHOddfZ.js";
import { b as getOffersAPI } from "./marketplace-D7e-ZNOV.js";
import { M as MarketplaceContext } from "./index-5RsiIq7B.js";
const ENVIRONMENTS = {
  DEVELOPMENT: "development",
  PRODUCTION: "production",
  QA: "qa"
};
const useIsTestMode = () => {
  const [isTestMode, setIsTestMode] = useState(false);
  useEffect(() => {
    if (!isWindowDefined()) return;
    const windowParams = new URL(window.location.href).searchParams;
    setIsTestMode(windowParams.has(TEST_MODE_QUERY_PARAM) && Boolean(windowParams.get(TEST_MODE_QUERY_PARAM)));
  }, []);
  return isTestMode;
};
const useFetchOffers = ({ environment = "production" }) => {
  const [offers, setOffers] = useState([]);
  const [offersError, setOffersError] = useState(null);
  const [offersSuccess, setOffersSuccess] = useState(false);
  const { filters } = useContext(MarketplaceContext);
  const fetchOffers = useCallback(async (signal) => {
    try {
      const res = await window.fetch(getOffersAPI({ environment, filters }), { signal });
      if (!res.ok) throw new Error(`Error: ${res.statusText}`);
      const response = await res.json();
      setOffers((response == null ? void 0 : response.offers) ?? []);
      setOffersSuccess(true);
    } catch (err) {
      if (signal.aborted) return;
      setOffersError(err.message);
      console.error("Something went wrong getting the offers:", { err });
    }
  }, [environment, filters]);
  useEffect(() => {
    if (!isWindowDefined()) return;
    const controller = new AbortController();
    const signal = controller.signal;
    fetchOffers(signal);
    return () => controller.abort();
  }, [fetchOffers]);
  return { offers, offersError, offersSuccess };
};
export {
  ENVIRONMENTS as E,
  useIsTestMode as a,
  useFetchOffers as u
};
//# sourceMappingURL=useFetchOffers-VKCBUaRy.js.map
